import React from 'react';
import {useTranslation} from "@nic-react-i18n/core";


export interface EmptyEventInterface {
    showIcon?: boolean;
    style?: React.CSSProperties;
}

const EmptyEvent: React.FC<EmptyEventInterface> = (props) => {
    const {t} = useTranslation()
    const {style} = props;
    const show = (props.showIcon ?? false);
    return (
        <div style={style}>
            { show &&
                <div>
                    <i className={'fal fa-ban'} style={{fontSize: '20pt', color: 'orange'}}/>
                </div>
            }
            <div>
                {t('emptyEvents')}
            </div>
        </div>
    );
};
export default EmptyEvent;